import React from "react";
import "./FacilityPerformance.less";
import { Button } from "@material-ui/core";

class FacilityPerformanceSectionData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <>
        <div>
          <Button
            className={"facility-perf-btn"}
            variant={"contained"}
            style={{ border: "1px solid green", width: "30px" }}
          >
            {"P1-1\r"}
          </Button>
        </div>
        <span style={{ textAlign: "center" }}>
          <h1>{"DH1-P1-1 GENERATOR"}</h1>
        </span>
        <div className={"row"}>
          <div className={"col-xs-4"}>
            <table>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"Status"}</td>
                <td>
                  <button type={"button"}
                    variant={"contained"}
                    style={{ border: "1px solid red", width: "70px" }}
                  >
                    {"Running\r"}
                  </button>
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"Fuel"}</td>
                <td>
                  <button type={"button"}
                    variant={"contained"}
                    style={{ border: "1px solid red", width: "40px" }}
                  >
                    {"40%\r"}
                  </button>
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"STARTS"}</td>
                <td>{"10"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"RUN HRS"}</td>
                <td>{"150"}</td>
              </tr>
            </table>
          </div>
          <div className={"col-xs-4"}>
            <table>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"VOLTS A-B"}</td>
                <td>{"480"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"VOLTS B-C"}</td>
                <td>{"480"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"VOLTS C-A"}</td>
                <td>{"480"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"VOLTS A"}</td>
                <td>{"277"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"VOLTS B"}</td>
                <td>{"277"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"VOLTS C"}</td>
                <td>{"277"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"AMPS A"}</td>
                <td>{"1500"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"AMPS B"}</td>
                <td>{"1500"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"AMPS C"}</td>
                <td>{"1500"}</td>
              </tr>
            </table>
          </div>
          <div className={"col-xs-4"}>
            <table>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"kW"}</td>
                <td>{"719.6"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"HZ"}</td>
                <td>{"60"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>
                  {"COOLANT TEMP\r"}
                </td>
                <td>{"160"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>{"OIL TEMP"}</td>
                <td>{"200"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "800", padding: "8px" }}>
                  {"BATT VOLTS\r"}
                </td>
                <td>{"12.6"}</td>
              </tr>
            </table>
          </div>
          <div className={"col-xs-12 end-xs"}>
            <Button
              className={"runReport-btn"}
              variant={"contained"}
              onClick={() => {
                this.props.onCancel();
              }}
            >
              {"Back\r"}
            </Button>
          </div>
        </div>
      </>
    );
  }
}

export default FacilityPerformanceSectionData;
